/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
import {AuthService} from '../../../components/security/authorization/auth.service';
import {MixinConstructor} from '../../../common/mixins/mixins';
import {Observable} from 'rxjs/Observable';
import {Principal} from '../../../components/security/authorization/principal.class';

export class UserAwareBase {
    constructor(readonly _authService: AuthService) {}
}

export const UserAware = <T extends MixinConstructor<UserAwareBase>>(Base: T = UserAwareBase as T) => {
    return class extends Base {

        user$: Observable<Principal | undefined>;
        userIsLoggedIn$: Observable<boolean>;

        constructor(...args: any[]) {
            super(...args);
            this.user$ = this._authService.user$;
            this.userIsLoggedIn$ = this._authService.userIsLoggedIn$;
        }

        logout() {
            this._authService.logout();
        }
    };
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/user/user-aware.class.ts